// Barra superior: marca, metadados da sessão e as duas ações globais.
// "Copiar tudo" copia o SOAP inteiro E marca a nota como copiada (POST /copiada,
// congela os diffs do piloto) — por isso o efeito fica no pai (EditorPage).
// "Encerrar e limpar" é só-cliente (a sessão expira sozinha em 24 h no servidor).
//
// Metadados: o mockup mostrava CÓDIGO · DATA · ÁUDIO. Só o código está disponível
// (o desktop o digitou no pareamento). Data da consulta não vem no GET e o áudio é
// apagado após o STT (Regra 6) — ambos omitidos por não terem fonte de dado.

import type { CSSProperties } from 'react';

import { btnPrimario, btnSecundario, cor, fonte } from '../../styles/tokens';

const barra: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 18,
  padding: '12px 24px',
  borderBottom: `1px solid ${cor.linha}`,
};

interface Props {
  codigo: string;
  onEncerrar: () => void;
  onCopiarTudo: () => void | Promise<void>;
  copiadoTudo: boolean;
}

export function Cabecalho({ codigo, onEncerrar, onCopiarTudo, copiadoTudo }: Props): JSX.Element {
  const codigoFmt = codigo.replace(/^(\d{3})(\d{3})$/, '$1 $2');
  return (
    <div style={barra}>
      <div style={{ fontFamily: fonte.condensada, fontWeight: 600, fontSize: 22, lineHeight: 1 }}>
        v<span style={{ color: cor.azul }}>med</span>
      </div>
      <div style={{ width: 1, height: 22, background: cor.linha }} />
      <div
        style={{ fontFamily: fonte.mono, fontSize: 12, letterSpacing: '.08em', color: cor.muted }}
      >
        CÓDIGO {codigoFmt}
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: 10, alignItems: 'center' }}>
        <button type="button" onClick={onEncerrar} style={{ ...btnSecundario, height: 38 }}>
          Encerrar e limpar
        </button>
        <button
          type="button"
          onClick={() => void onCopiarTudo()}
          style={{ ...btnPrimario, height: 38, fontSize: 15, paddingInline: 18 }}
        >
          {copiadoTudo ? 'Copiado ✓' : 'Copiar tudo'}
        </button>
      </div>
    </div>
  );
}
